<template>
  <tr>
    <td class="px-0">
      <v-list-item class="py-3">
        <template v-slot:prepend>
          <v-avatar size="38" :color="contact.color">
            <v-icon size="18">{{ contact.icon }}</v-icon>
          </v-avatar>
        </template>
        <v-list-item-title style="color: unset">
          {{ contact.type }}
        </v-list-item-title>
      </v-list-item>
    </td>
    <td>
      {{ contact.phoneEmail }}
    </td>

    <td>
      {{ contact.channel }}
    </td>

    <td>
      {{ contact.disposition }}
    </td>
    <td>
      {{ isBlocked }}
    </td>
    <td v-html="contact.dateReceived"></td>

    <!-- Actions -->
    <td>
      <v-btn variant="outlined" size="36" color="grey" icon="" @click.stop="">
        <v-icon>fa-solid fa-ellipsis-vertical</v-icon>
        <v-tooltip
          activator="parent"
          location="top"
          text="Click to see actions"
        />
        <v-menu activator="parent">
          <v-list>
            <v-list-item @click="toggleBlocking">
              <v-list-item-title>
                {{ toggleBlockingMenuTitle }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-btn>
    </td>
    <confirmation-dialog
      :title="confirmationDialogTitle"
      :text="confirmationDialogBody"
      secondary-text="Are you sure?"
      cancelText="Cancel"
      confirmText="Yes"
      :dialog="confirmationDialog"
      @confirm="confirmationConfirmed"
      @cancel="confirmationCancel"
    />
    <v-snackbar v-bind="alert" :color="alertColor" multi-line top>
      {{ alertText }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text fab small @click="alert = false">
          <v-icon>close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </tr>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { useEventBus } from "@/event-bus/bus";
import api from "@/services/api.js";
import C from "@/utils/constants";

export default {
  name: "DNCListRow",
  components: {
    ConfirmationDialog: defineAsyncComponent(
      () => import("@/components/console/dialog/ConfirmationDialog"),
    ),
  },
  props: {
    contact: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isPhoneType() {
      return this.contact.type === "Phone";
    },
    isBlocked() {
      return this.contact.blocked === true ? "Yes" : "No";
    },
    toggleBlockingMenuTitle() {
      return this.contact.blocked === true ? "Unblock Number" : "Block Number";
    },
  },
  data() {
    return {
      confirmationDialogTitle: "",
      confirmationDialogBody: "",
      confirmationDialog: false,
      alert: false,
      alertColor: "success",
      alertText: "",
    };
  },
  methods: {
    toggleBlocking() {
      // only available for phone contact type
      console.log(this.isBlocked);
      console.log("Toggle blocking clicked");
      if (this.isBlocked === "YES") {
        this.confirmationDialog = true;
        this.confirmationDialogTitle = "Unblock Number";
        this.confirmationDialogBody =
          "This will ALLOW inbound calls and SMS messages from this number.";
      } else {
        this.confirmationDialog = true;
        this.confirmationDialogTitle = "Block Number";
        this.confirmationDialogBody =
          "This will Block ALL inbound calls and SMS messages from this number.";
      }
    },
    confirmationConfirmed() {
      this.confirmationDialog = false;
      this.dialog = false;
      this.patchPhoneDNC();
      console.log("WE SAID YES!");
    },
    confirmationCancel() {
      console.log("WE SAID CANCEL!");
      this.confirmationDialog = false;
    },
    async patchPhoneDNC() {
      try {
        let blockedStatus = !this.contact.blocked;
        let payload = {
          blocked: blockedStatus,
          // value: this.contact.phoneNumber
        };
        let { data } = await api.dnc.patchDNC(this.contact.id, payload);
        this.alertColor = "success";
        this.alertText =
          blockedStatus === true
            ? "Successfully blocked the number."
            : "Successfully unblocked the number.";

        const _eventBus = useEventBus();
        _eventBus.$emit(C.EVENT_BUS.RELOAD_DNC_LIST);
        console.log(data);
      } catch (e) {
        this.alertColor = "error";
        if (e.response && e.response.data && e.response.data.message !== "") {
          this.alertText = e.response.data.message;
        } else {
          this.alertText = "An error occurred please try again.";
        }
      } finally {
        this.alert = true;
        console.log("done patching!");
      }
    },
  },
};
</script>

<style scoped>
.v-btn :deep(.v-icon) {
  font-size: 20px;
}
</style>
